import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "flag-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round" },
        React.createElement("path", { d: "M2.5 2.5v12" }),
        React.createElement("path", { fill: "currentColor", fillOpacity: 0.2, fillRule: "evenodd", strokeLinejoin: "round", d: "M4.5 2.5v7h10L11 6l3.5-3.5z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
